import { post } from "../../services";
import {
    LIST_ALL_PMS_UPDATES,
    LIST_PMS_UPDATE_DETAILS
} from "../../graphql";
import {
    RESET_ALL_PMS_UPDATES,
    RESET_PMS_UPDATE_DETAILS,
    SAVE_ALL_PMS_UPDATES,
    SAVE_PMS_UPDATE_DETAILS,
    TOGGLE_LOADING
} from "../types";


export const listAllPmsUpdates = (requestData) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
        const {
            pmsUpdates: { pageSize, pageNumber },
        } = getState().pms;

        let apiResponse = await post("", {
            query: LIST_ALL_PMS_UPDATES,
            variables: {
                ...requestData,
                pageSize: requestData?.pageSize || pageSize,
                pageNumber: requestData?.pageNumber || pageNumber,
            },
        });

        if (apiResponse.data.customStatus) {
            let {
                list_all_pms_updates: { data, hasMore, count },
            } = apiResponse.data.data;

            dispatch({
                type: SAVE_ALL_PMS_UPDATES,
                payload: {
                    list: data,
                    showViewMore: hasMore,
                    pageSize: requestData?.pageSize || pageSize,
                    pageNumber: requestData?.pageNumber || pageNumber,
                    count: count,
                },
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAllPmsUpdates = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_PMS_UPDATES });
    };
};

export const listPmsUpdateDetails = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: LIST_PMS_UPDATE_DETAILS,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                list_pms_update_details: { data },
            } = apiResponse.data.data;
            dispatch({
                type: SAVE_PMS_UPDATE_DETAILS,
                payload: data,
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetPmsUpdateDetails = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_PMS_UPDATE_DETAILS });
    };
};
